/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { Gender } from 'app/shared/model/enumerations/gender.model';

export interface ILabTestItemLimit {
  id?: string;
  active?: boolean;
  lastUpdated?: number;
  timestampEntry?: number;
  microSec?: number;
  cursor?: number;
  unitsOfMeasure?: string | null;
  resultType?: string | null;
  normalRangeLowerLimit?: string | null;
  normalRangeUpperLimit?: string | null;
  possibleRangeLowerLimit?: string | null;
  possibleRangeUpperLimit?: string | null;
  template?: string | null;
  ageMin?: number | null;
  ageMax?: number | null;
  gender?: keyof typeof Gender | null;
  weightMin?: number | null;
  weightMax?: number | null;
  bsaMin?: number | null;
  bsaMax?: number | null;
  displayPrecision?: boolean | null;
  testItem?: ILabTestItem;
  lab?: IDiagLab | null;
}

export const defaultValue: Readonly<ILabTestItemLimit> = {
  active: false,
  displayPrecision: false,
};
